import type { Website } from '@lensora/shared'
import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'

export const ACTIVE_WEBSITE_STORAGE_KEY = 'lensora_active_website_id'

export function useWebsites() {
  return useQuery({
    queryKey: ['websites'],
    queryFn: () => api.get<Website[]>('/api/websites'),
    staleTime: 60_000,
  })
}

export function useActiveWebsite() {
  const { data, ...rest } = useWebsites()
  const list = Array.isArray(data) ? data : []
  const storedId =
    typeof localStorage !== 'undefined' ? localStorage.getItem(ACTIVE_WEBSITE_STORAGE_KEY) : null
  const website = (storedId ? list.find((w) => w.id === storedId) : null) ?? list[0] ?? null

  return { website, websiteId: website?.id ?? null, websites: list, ...rest }
}
